export default "__VITE_ASSET__Dy3_6IVm__"